import {ScheduleStatus} from "../../../gd/types/types";
import Task from "../task";


export function taskUpdateSchedule(task:Task, scheduleDate:Moment|null,  scheduleStatus:ScheduleStatus) {

    // Patch / validatero
    if (!scheduleDate && scheduleStatus === ScheduleStatus.SCHEDULED) {
        console.warn("#djd9273730 - what??? how come ????")
        return
    }


    switch (scheduleStatus) {

        case ScheduleStatus.SCHEDULED:
            task.scheduleStatus = scheduleStatus
            task.scheduleDate   = scheduleDate
            break;

        case ScheduleStatus.SOMEDAY:
            task.scheduleStatus = scheduleStatus
            // task.scheduleDate   = scheduleDate
            if (task.scheduleDate) task.scheduleDate = null
            break

        case ScheduleStatus.NOT_SCHEDULED:
            task.scheduleStatus = scheduleStatus
            if (task.scheduleDate) task.scheduleDate = null
            break

        default:
            throw Error("#12312393 impossible")
    }
}

